module.exports = __webpack_public_path__ + "static/media/illustration-rptstd-details-responsive.404f26cb.svg";